import type { LobbyEvent } from '@danda/shared';
import { lobbyEventSchema, lobbyEventSchemas } from './websocket-event-schemas';

export type ParsedLobbyEvent = LobbyEvent | { type: 'pong' };

export function parseLobbyMessage(data: string): ParsedLobbyEvent | null {
  try {
    const raw = JSON.parse(data);
    const parsed = lobbyEventSchema.safeParse(raw);

    if (!parsed.success) {
      console.warn('[WS] Dropping invalid lobby event', parsed.error.issues);
      return null;
    }

    const event = parsed.data as ParsedLobbyEvent;

    const schema = lobbyEventSchemas[event.type as keyof typeof lobbyEventSchemas];
    if (schema) {
      const refined = schema.safeParse(raw);
      if (!refined.success) {
        console.warn('[WS] Dropping lobby event that failed shape validation', {
          type: event.type,
          issues: refined.error.issues,
        });
        return null;
      }
    }

    return event;
  } catch (error) {
    console.error('Failed to parse WebSocket message:', error, data);
    return null;
  }
}
